/* Delivery promise for Meubel31. Shared by the product page, sticky bar and cart drawer, and unit tested.

   Rules:
   - Nothing is shipped or delivered on Sunday, ever.
   - Shipping Monday to Friday. Saturday only when M31DeliveryConfig.shipSaturday is true.
   - Delivery Monday to Friday. Saturday only when M31DeliveryConfig.deliverSaturday is true.
   - "a/b": delivery a to b delivery days after the day the order ships. An order on Saturday or
     Sunday ships Monday, so the window starts counting from Monday.
   - "delivery_dd-mm-yyyy" (or "dd-mm-yyyy"): fixed date. Moved to the next delivery day when it falls
     on a Sunday or closed day, and never earlier than the first delivery that is still possible.
   - Optional: M31DeliveryConfig.cutoff ("15:00"), after which today no longer counts as a shipping day,
     and M31DeliveryConfig.closedDates ("25-12-2026, 26-12-2026"), no shipping and no delivery.
   - "Today" is taken in Dutch/Belgian time, not from the visitor's clock.

   API unchanged: M31Delivery.deliveryText(windowValue, now) returns the text or null.
   Extra: an optional third argument with the same options as M31DeliveryConfig (for tests),
   and M31Delivery.deliveryRange(...) returning { from, to } as Date objects. */
(function (root) {
  var DAY = 86400000;
  var TZ = 'Europe/Amsterdam';
  // Dates are kept as UTC noon of the calendar day, so formatting in UTC never shifts a day
  var fmtDay = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric' });
  var fmtFull = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
  var fmtMonth = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', month: 'long' });
  var fmtLocal = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });

  function stamp(y, m, d) { return Date.UTC(y, m - 1, d, 12); }

  // "delivery_dd-mm-yyyy" or "dd-mm-yyyy" -> day stamp, else null
  function parseDate(value) {
    var m = String(value || '').trim().replace(/^delivery_/, '').match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    return m ? stamp(Number(m[3]), Number(m[2]), Number(m[1])) : null;
  }

  function settings(options) {
    var c = options || root.M31DeliveryConfig || {};
    var cut = String(c.cutoff || '').trim().match(/^(\d{1,2})[:.u](\d{2})$/);
    var closed = {};
    String(c.closedDates || '').split(/[\s,;]+/).forEach(function (s) {
      var t = parseDate(s);
      if (t) closed[t] = true;
    });
    return {
      shipSat: c.shipSaturday === true,
      deliverSat: c.deliverSaturday === true,
      cutoff: cut ? Number(cut[1]) * 60 + Number(cut[2]) : null,
      closed: closed
    };
  }

  // Calendar day and minutes past midnight in Dutch/Belgian time
  function localNow(now) {
    var p = {};
    fmtLocal.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { day: stamp(Number(p.year), Number(p.month), Number(p.day)), minutes: Number(p.hour) * 60 + Number(p.minute) };
  }

  function weekday(t) { return new Date(t).getUTCDay(); }

  function isShipDay(t, s) {
    var d = weekday(t);
    if (d === 0 || (d === 6 && !s.shipSat)) return false;
    return !s.closed[t];
  }

  function isDeliveryDay(t, s) {
    var d = weekday(t);
    if (d === 0 || (d === 6 && !s.deliverSat)) return false;
    return !s.closed[t];
  }

  function onOrAfterDeliveryDay(t, s) {
    for (var i = 0; i < 90 && !isDeliveryDay(t, s); i++) t += DAY;
    return t;
  }

  function addDeliveryDays(t, n, s) {
    for (var i = 0; i < 180 && n > 0; i++) {
      t += DAY;
      if (isDeliveryDay(t, s)) n--;
    }
    return onOrAfterDeliveryDay(t, s);
  }

  // The day the order leaves the warehouse
  function shipDay(now, s) {
    var t = now.day;
    if (isShipDay(t, s) && (s.cutoff === null || now.minutes < s.cutoff)) return t;
    for (var i = 0; i < 90; i++) {
      t += DAY;
      if (isShipDay(t, s)) return t;
    }
    return t;
  }

  function deliveryRange(windowValue, now, options) {
    var s = settings(options);
    var local = localNow(now || new Date());
    var ships = shipDay(local, s);
    var value = String(windowValue || '').trim();

    var fixed = parseDate(value);
    if (fixed) {
      var first = addDeliveryDays(ships, 1, s);
      var day = onOrAfterDeliveryDay(Math.max(fixed, first), s);
      return { from: new Date(day), to: new Date(day) };
    }

    var days = value.split('/').map(Number);
    if (days.length === 1) days.push(days[0]);
    if (days.length !== 2 || days.some(isNaN) || value === '') return null;
    var low = Math.max(0, Math.min(days[0], days[1]));
    var high = Math.max(0, days[0], days[1]);
    return {
      from: new Date(addDeliveryDays(ships, low, s)),
      to: new Date(addDeliveryDays(ships, high, s))
    };
  }

  function deliveryText(windowValue, now, options) {
    var r = deliveryRange(windowValue, now, options);
    if (!r) return null;
    var start = r.from;
    var end = r.to;
    if (start.getTime() === end.getTime()) return 'Verwachte levering ' + fmtFull.format(start);
    if (start.getUTCMonth() === end.getUTCMonth()) {
      return 'Verwachte levering ' + fmtDay.format(start) + ' of ' + fmtDay.format(end) + ' ' + fmtMonth.format(end);
    }
    return 'Verwachte levering ' + fmtFull.format(start) + ' of ' + fmtFull.format(end);
  }

  root.M31Delivery = { deliveryText: deliveryText, deliveryRange: deliveryRange };
  if (typeof module === 'object' && module.exports) module.exports = root.M31Delivery;
})(typeof window !== 'undefined' ? window : globalThis);
